<controls-bo-piechart *ngIf="chartForm?.value?.chartType =='pieChart'" [chartForm]="chartForm">
</controls-bo-piechart>
<controls-bo-donutchart *ngIf="chartForm?.value?.chartType =='donutChart'" [chartForm]="chartForm">
</controls-bo-donutchart>
<controls-bo-linechart *ngIf="chartForm?.value?.chartType =='lineChart'" [chartForm]="chartForm">
</controls-bo-linechart>
<controls-bo-barchart *ngIf="chartForm?.value?.chartType =='barChart'" [chartForm]="chartForm">
</controls-bo-barchart>
<controls-bo-stackedbarchart *ngIf="chartForm?.value?.chartType =='stackedbarChart'" [chartForm]="chartForm">
</controls-bo-stackedbarchart>
<controls-bo-gaugechart *ngIf="chartForm?.value?.chartType =='gauge'" [chartForm]="chartForm">
</controls-bo-gaugechart>